import {
  CategorizationSource,
  CategorizationSourceBase,
  TopLevelCategorizationSource,
} from "models/CategorizationSource";
import * as _ from "lodash";
import { categorizationOntology as defaultCategorizationOntology } from "data/categorizationOntology";

export interface CategorizationOntologyWrapper {
  categorizations: TopLevelCategorizationSource[];
}

export interface CategorizationSourceDictionary {
  [catid: string]: CategorizationSourceBase;
}

// The categorizationSourceDictionary contains ALL items, including deprecated items
// and of any entityType value. Filtering occurs in other functions.
export const getCategorizationSourceDictionary = (
  categorizationOntology: CategorizationOntologyWrapper = defaultCategorizationOntology as unknown as CategorizationOntologyWrapper,
): CategorizationSourceDictionary => {
  const children = _.chain(
    categorizationOntology.categorizations as TopLevelCategorizationSource[],
  )
    .map("child")
    .flatten()
    .value() as CategorizationSource[];
  const parents = _.cloneDeep(categorizationOntology.categorizations);
  parents.forEach((parent) => {
    delete (parent as any).child;
  });
  const flattenedCategorizationSource = (children as CategorizationSourceBase[])
    .concat(parents as CategorizationSourceBase[])
    .filter((item) => item?.categorization);

  const catDictionary: CategorizationSourceDictionary = {};
  flattenedCategorizationSource.forEach((cat) => {
    const catClone: any = { ...cat };
    const id = catClone.cnetID;
    delete catClone.cnetID;
    catDictionary[id] = catClone;
  });

  return catDictionary;
};

// Built once from the bundled default ontology so lookups can be called with
// just an id (the amwebform forms only use the default categorization tree).
const defaultDictionary = getCategorizationSourceDictionary();

// Looks at all possible item types, including deprecated and all entityTypes.
// Returns all item data.
export const getItemById = (
  id: string | null,
  categorizationOntology: CategorizationSourceDictionary = defaultDictionary,
): CategorizationSourceBase | null => {
  if (!id) {
    console.error(`Requested category with invalid ID: ${id}`);
    return null;
  }

  return categorizationOntology[id] || null;
};

// Looks at all possible item types, including deprecated and all entityTypes.
// Returns only the category label.
export const getCategoryById = (
  id: string | null,
  categorizationOntology: CategorizationSourceDictionary = defaultDictionary,
): string | null =>
  getItemById(id, categorizationOntology)?.categorization || null;
